import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";

const DatePicker = (props) => {
  const [showPicker, setShowPicker] = useState(false);
  const [currentDate, setCurrentDate] = useState(new Date());

  const [year, setYear] = useState(currentDate.getFullYear());

  const getMonthName = (date) => {
    const userLanguage = navigator.language || navigator.userLanguage;
    const isEnglish = userLanguage.startsWith("en");

    const options = { month: "long" };
    const formatter = new Intl.DateTimeFormat(isEnglish ? "en" : "en", options);
    return formatter.format(date);
  };

  useEffect(() => {
    setMonth(getMonthName(currentDate));
  }, [currentDate]);

  const [month, setMonth] = useState(getMonthName(currentDate));

  const [monthNumber, setMonthNumber] = useState(currentDate.getMonth());

  const firstDay = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth(),
    1
  );
  const [day, setDay] = useState(firstDay.getDay());

  //fix of 32 dec to 31 dec
  const currentDay = currentDate.getDate();

  const lastDayOfMonth = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth() + 1,
    0
  ).getDate();

  const initialSelectedDay = props.noDefault
    ? null
    : props.parent === "A5"
      ? currentDay
      : currentDay === lastDayOfMonth
      ? currentDay
      : currentDay + 1;

  const [selectedDay, setSelectedDay] = useState(initialSelectedDay);

  //   const [selectedDay, setSelectedDay] = useState(
  //     props.parent === "A5" ? currentDate.getDate() : currentDate.getDate() + 1
  //   );

  const [element, setElement] = useState([]);

  const [countminMonth, setCountminMonth] = useState(
    parseInt(props.dateData.from_day / 30)
  );

  const [countmaxMonth, setCountmaxMonth] = useState(
    parseInt(props.dateData.to_day / 30)
  );

  const [fromDay, setFromDay] = useState(props.dateData.from_day % 30);
  const [toDay, setToDay] = useState(props.dateData.to_day % 30);
  const [pDay, setPDay] = useState(currentDate.getDate() + fromDay);

  // const [count,setCount] = useState(0)
  const wrapperRef1 = useRef(null);
  useOutsideAlerter(wrapperRef1);
  console.log(
    "propsDatePicker",
    props,
    props.dateData && props.dateData.from_day,
    props.dateData && props.dateData.to_day
  );

  function useOutsideAlerter(ref) {
    useEffect(() => {
      /**
       * Alert if clicked on outside of element
       */
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setShowPicker(false);
        }
      }

      // Bind the event listener
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  const prevLastDate = moment()
    .add(props.dateData.from_day, "days")
    .format("DD/MM/YYYY");
  const nextLastDate = moment()
    .add(props.dateData.to_day, "days")
    .format("DD/MM/YYYY");

  const minDate = moment().add(parseInt(props.dateData.from_day), "days");
  const maxDate = moment().add(parseInt(props.dateData.to_day), "days");

  const isDateDisabled = (dayNum) => {
    const date = moment(`${dayNum}/${monthNumber + 1}/${year}`, "D/M/YYYY");
    return date.isBefore(minDate, "day") || date.isAfter(maxDate, "day");
  };

  let count = 1;

  console.log(
    "currentDate",
    currentDate,
    selectedDay,
    prevLastDate,
    nextLastDate
  );

  function addMonths(date, months) {
    var d = date.getDate();
    date.setMonth(date.getMonth() + +months);
    if (date.getDate() != d) {
      date.setDate(0);
    }
    return date;
  }

  useEffect(() => {
    //  Add conditions for selection day according to given days
    const prevLastMonth = moment(prevLastDate, "DD/MM/YYYY").month();
    const prevLastYear = moment(prevLastDate, "DD/MM/YYYY").year();
    const nextLastMonth = moment(nextLastDate, "DD/MM/YYYY").month();
    const nextLastYear = moment(nextLastDate, "DD/MM/YYYY").year();
    const prevLastDay = moment(prevLastDate, "DD/MM/YYYY").date();
    const nextLastDay = moment(nextLastDate, "DD/MM/YYYY").date();

    if (selectedDay && document.getElementById(selectedDay)) {
      document.getElementById(selectedDay).style.backgroundColor = "yellow";
    }
  }, [showPicker]);

  const handlePrevDate = (e, currentDate) => {
    let current;
    const prevLastMonth = moment(prevLastDate, "DD/MM/YYYY").month();
    const prevLastYear = moment(prevLastDate, "DD/MM/YYYY").year();
    console.log(
      "prevLastMonthyaer",
      prevLastMonth,
      prevLastYear,
      monthNumber,
      year
    );
    if (year > prevLastYear) {
      current = addMonths(currentDate, -1);
      setCurrentDate(current);
      setMonth(getMonthName(currentDate));
      // setMonth(currentDate.toLocaleString("default", { month: "long" }));
      setMonthNumber(currentDate.getMonth());
      setYear(currentDate.getFullYear());
      const firstDay = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        1
      );
      setDay(firstDay.getDay());
    } else if (year === prevLastYear && monthNumber > prevLastMonth) {
      current = addMonths(currentDate, -1);
      setCurrentDate(current);
      // setMonth(currentDate.toLocaleString("default", { month: "long" }));
      setMonth(getMonthName(currentDate));
      setMonthNumber(currentDate.getMonth());
      setYear(currentDate.getFullYear());
      const firstDay = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        1
      );
      setDay(firstDay.getDay());
    }
    if (selectedDay && document.getElementById(selectedDay)) {
      document.getElementById(selectedDay).style.backgroundColor = "#f6f6f6";
    }
    count = 0;
    console.log("currentDateNew", countminMonth, countmaxMonth, current);
  };

  const handleNextDate = (e, currentDate) => {
    let current;
    const nextLastMonth = moment(nextLastDate, "DD/MM/YYYY").month();
    const nextLastYear = moment(nextLastDate, "DD/MM/YYYY").year();

    if (year < nextLastYear) {
      current = addMonths(currentDate, 1);
      setCurrentDate(current);
      // setMonth(currentDate.toLocaleString("default", { month: "long" }));
      setMonth(getMonthName(currentDate));
      setYear(currentDate.getFullYear());
      setMonthNumber(currentDate.getMonth());
      const firstDay = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        1
      );
      setDay(firstDay.getDay());
    } else if (year === nextLastYear && monthNumber < nextLastMonth) {
      current = addMonths(currentDate, 1);
      setCurrentDate(current);
      // setMonth(currentDate.toLocaleString("default", { month: "long" }));
      setMonth(getMonthName(currentDate));
      setYear(currentDate.getFullYear());
      setMonthNumber(currentDate.getMonth());
      const firstDay = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        1
      );
      setDay(firstDay.getDay());
    }

    if (selectedDay && document.getElementById(selectedDay)) {
      document.getElementById(selectedDay).style.backgroundColor = "#f6f6f6";
    }
    count = 0;

    console.log("currentDateNew", countmaxMonth, countminMonth, current);
  };

  const handleSelect = (e, day) => {
    const prevLastMonth = moment(prevLastDate, "DD/MM/YYYY").month();
    const prevLastYear = moment(prevLastDate, "DD/MM/YYYY").year();
    const nextLastMonth = moment(nextLastDate, "DD/MM/YYYY").month();
    const nextLastYear = moment(nextLastDate, "DD/MM/YYYY").year();
    const prevLastDay = moment(prevLastDate, "DD/MM/YYYY").date();
    const nextLastDay = moment(nextLastDate, "DD/MM/YYYY").date();

    console.log(
      "currentDateSelect",
      prevLastMonth,
      prevLastYear,
      nextLastMonth,
      nextLastYear,
      prevLastDay,
      nextLastDay,
      props.dateData.from_day,
      props.dateData.to_day
    );

    function getMonthFromString(month) {
      var d = Date.parse(month + "1, 2020");
      if (!isNaN(d)) {
        return new Date(d).getMonth() + 1;
      }
      return -1;
    }
    if (year === prevLastYear && monthNumber === prevLastMonth) {
      if (e.target.innerHTML >= prevLastDay) {
        const id = e.target.id;
        const ele = (document.getElementById(id).style.backgroundColor =
          "yellow");
        const data = [...element, id];
        setElement([...element, id]);
        if (document.getElementById(selectedDay)) {
          document.getElementById(selectedDay).style.backgroundColor =
            "#f6f6f6";
        }
        data.map((i) => {
          if (i !== id && document.getElementById(i)) {
            document.getElementById(i).style.backgroundColor = "none";
            console.log(
              "currentDateSelectnew",
              (document.getElementById(i).style.backgroundColor = "#f6f6f6")
            );
          }
        });
        setSelectedDay(e.target.innerHTML);
        setShowPicker(false);
        props.parentCallback(
          e.target.innerHTML + "/" + getMonthFromString(month) + "/" + year,
          props.type
        );
      }
    } else if (year === nextLastYear && monthNumber === nextLastMonth) {
      if (e.target.innerHTML <= nextLastDay) {
        const id = e.target.id;
        const ele = (document.getElementById(id).style.backgroundColor =
          "yellow");
        const data = [...element, id];
        setElement([...element, id]);
        if (document.getElementById(selectedDay)) {
          document.getElementById(selectedDay).style.backgroundColor =
            "#f6f6f6";
        }
        data.map((i) => {
          if (i !== id && document.getElementById(i)) {
            document.getElementById(i).style.backgroundColor = "none";
            console.log(
              "currentDateSelectnew",
              (document.getElementById(i).style.backgroundColor = "#f6f6f6")
            );
          }
        });
        setSelectedDay(e.target.innerHTML);

        props.parentCallback(
          e.target.innerHTML + "/" + getMonthFromString(month) + "/" + year,
          props.type
        );
        console.log(
          "checkprev",
          props.dateData.from_day,
          countminMonth,
          e.target.innerHTML,
          currentDate.getDate() + (props.dateData.from_day % 30)
        );
        setShowPicker(false);
      }
    } else {
      const id = e.target.id;
      const ele = (document.getElementById(id).style.backgroundColor =
        "yellow");
      const data = [...element, id];
      setElement([...element, id]);
      if (document.getElementById(selectedDay)) {
        document.getElementById(selectedDay).style.backgroundColor = "#f6f6f6";
      }
      data.map((i) => {
        if (i !== id && document.getElementById(i)) {
          document.getElementById(i).style.backgroundColor = "none";
          console.log(
            "currentDateSelectnew",
            (document.getElementById(i).style.backgroundColor = "#f6f6f6")
          );
        }
      });
      setSelectedDay(e.target.innerHTML);
      setShowPicker(false);
      props.parentCallback(
        e.target.innerHTML + "/" + getMonthFromString(month) + "/" + year,
        props.type
      );
    }
  };

  return (
    <>
      <div>
        <div className="form-group field dateContr">
          <label className="sel active">{props.message}</label>
          <input
            type="text"
            disabled={props.disable}
            className="form-control form-icon arrow-andicon hasDatepicker"
            placeholder={
              props.initialDate ||
              (selectedDay ? selectedDay + " " + month + " " + year : "Select a date")
            }
            readOnly={true}
            id="fromdate"
            onClick={() => {
              setShowPicker(!showPicker);
              console.log(
                "selectedDayId",
                selectedDay,
                document.getElementById(props.selectDay)
              );
              if (showPicker)
                document.getElementById("ui-datepicker-div").style.margin =
                  "0px";
            }}
          />

          <div className="height50">&nbsp;</div>
        </div>

        {showPicker && ReactDOM.createPortal(
          <div className="datepicker-overlay" onClick={() => setShowPicker(false)}>
          <div
            ref={wrapperRef1}
            id="ui-datepicker-div"
            className="ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all datepicker-centered"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="ui-datepicker-header ui-widget-header ui-helper-clearfix ui-corner-all">
              <a
                className="ui-datepicker-prev ui-corner-all"
                data-handler="prev"
                data-event="click"
                title="Prev"
                onClick={(e) => handlePrevDate(e, currentDate)}
              >
                <span className="ui-icon ui-icon-circle-triangle-w">Prev</span>
              </a>
              <a
                className="ui-datepicker-next ui-corner-all"
                data-handler="next"
                data-event="click"
                title="Next"
                onClick={(e) => handleNextDate(e, currentDate)}
              >
                <span className="ui-icon ui-icon-circle-triangle-e">Next</span>
              </a>
              <div className="ui-datepicker-title">
                <span className="ui-datepicker-month">{month}</span>&nbsp;
                <span className="ui-datepicker-year">{year}</span>
              </div>
            </div>
            <table className="ui-datepicker-calendar">
              <thead>
                <tr>
                  <th scope="col" className="ui-datepicker-week-end">
                    <span title="Sunday">Su</span>
                  </th>
                  <th scope="col">
                    <span title="Monday">Mo</span>
                  </th>
                  <th scope="col">
                    <span title="Tuesday">Tu</span>
                  </th>
                  <th scope="col">
                    <span title="Wednesday">We</span>
                  </th>
                  <th scope="col">
                    <span title="Thursday">Th</span>
                  </th>
                  <th scope="col">
                    <span title="Friday">Fr</span>
                  </th>
                  <th scope="col" className="ui-datepicker-week-end">
                    <span title="Saturday">Sa</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  {new Array(day).fill(undefined).map((index, value) => (
                    <td className=" ui-datepicker-other-month ui-datepicker-unselectable ui-state-disabled">
                      &nbsp;
                    </td>
                  ))}

                  {new Array(7 - day).fill(undefined).map((index, value) => (
                    <td
                      className=" "
                      data-handler="selectDay"
                      data-event="click"
                      data-month="11"
                      data-year="2021"
                    >
                      <a
                        id={count}
                        className={`ui-state-default ${isDateDisabled(count) ? "ui-state-disabled" : ""}`}
                        href="#"
                        onClick={(e) => {
                          if (isDateDisabled(parseInt(e.target.innerHTML))) return;
                          handleSelect(e, count);
                        }}
                      >
                        {count++}
                      </a>
                    </td>
                  ))}
                </tr>

                {new Array(4).fill(undefined).map((index, value) => (
                  <tr>
                    {new Array(7).fill(undefined).map(
                      (index, value) =>
                        (month === "January" ||
                        month === "March" ||
                        month === "May" ||
                        month == "July" ||
                        month === "August" ||
                        month === "October" ||
                        month === "December"
                          ? count < 32
                          : month === "February"
                          ? year % 4 === 0
                            ? count < 30
                            : count < 29
                          : count < 31) && (
                          <td
                            className=" "
                            data-handler="selectDay"
                            data-event="click"
                            data-month="11"
                            data-year="2021"
                          >
                            <a
                              id={count}
                              className={`ui-state-default ${isDateDisabled(count) ? "ui-state-disabled" : ""}`}
                              href="#"
                              onClick={(e) => {
                                if (isDateDisabled(parseInt(e.target.innerHTML))) return;
                                handleSelect(e);
                              }}
                            >
                              {count++}
                            </a>
                          </td>
                        )
                    )}
                  </tr>
                ))}
                <tr>
                  {new Array(7).fill(undefined).map(
                    (index, value) =>
                      (month === "January" ||
                      month === "March" ||
                      month === "May" ||
                      month == "July" ||
                      month === "August" ||
                      month === "October" ||
                      month === "December"
                        ? count < 32
                        : month === "February"
                        ? year % 4 === 0
                          ? count < 30
                          : count < 29
                        : count < 31) && (
                        <td
                          className=" "
                          data-handler="selectDay"
                          data-event="click"
                          data-month="11"
                          data-year="2021"
                        >
                          <a
                            id={count}
                            className={`ui-state-default ${isDateDisabled(count) ? "ui-state-disabled" : ""}`}
                            href="#"
                            onClick={(e) => {
                              if (isDateDisabled(parseInt(e.target.innerHTML))) return;
                              handleSelect(e);
                            }}
                          >
                            {count++}
                          </a>
                        </td>
                      )
                  )}
                </tr>
              </tbody>
            </table>
          </div>
          </div>,
          document.getElementById("top") || document.body
        )}
      </div>
    </>
  );
};

export default DatePicker;
